var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"admin__button",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v("ADMIN")])])}
var staticRenderFns = []

export { render, staticRenderFns }